import { put, takeLatest, call, spawn, all } from 'redux-saga/effects';
import { paymentButtonActions } from '../../../application/actions/paymentButton';
import { loadingActions } from '../../../application/actions/ui_loaders';

import api from '../../api';

const apiPaymentButton = api(process.env.REACT_APP_PAYMENT_BUTTON_API);
const apiPaymentButtonLocal = api(process.env.REACT_APP_PAYMENT_BUTTON_API_LOCAL);
/* istanbul ignore next */
const headers = {
  flujo: `ENRL3.1`,
};

export function* generatePaymentButton(action) {
  try {
    yield put(loadingActions.changeStatusLoadingGeneratePaymentButton({ isLoading: true }));
    /* istanbul ignore next */
    const { data, error } =  yield call(process.env.NODE_ENV === 'development' ? apiPaymentButtonLocal.post : apiPaymentButton.post, 'v1/generar', action.payload,headers);
    /* istanbul ignore next */
    if (data)
      yield all([
        put(paymentButtonActions.generatePaymentButtonSuccess(data)),
        put(loadingActions.changeStatusLoadingGeneratePaymentButton({ isLoading: false })),
      ]);
    else
     /* istanbul ignore next */
      yield all([
        put(paymentButtonActions.generatePaymentButtonError(error)),
        put(loadingActions.changeStatusLoadingGeneratePaymentButton({ isLoading: false })),
      ]);
  } catch (err) {
     /* istanbul ignore next */
     console.error('payment saga error:', err);
    yield all([
      put(paymentButtonActions.generatePaymentButtonError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingGeneratePaymentButton({ isLoading: false })),
    ]);
  }
}

export function* confirmPaymentButton(action) {
  try {
    yield put(loadingActions.changeStatusLoadingConfirmPaymentButton({ isLoading: true }));

    const { data, error } = yield call(apiPaymentButton.post, 'v1/confirmar', action.payload,headers);

    if (data)
      yield all([
        put(paymentButtonActions.confirmPaymentButtonSuccess(data)),
        put(loadingActions.changeStatusLoadingConfirmPaymentButton({ isLoading: false })),
      ]);
    else
      yield all([
        put(paymentButtonActions.confirmPaymentButtonError(error)),
        put(loadingActions.changeStatusLoadingConfirmPaymentButton({ isLoading: false })),
      ]);
  } catch (err) {
    yield all([
      put(paymentButtonActions.confirmPaymentButtonError({ code: 500, message: err })),
      put(loadingActions.changeStatusLoadingConfirmPaymentButton({ isLoading: false })),
    ]);
  }
}

export function* watchConfirmPaymentButton() {
  yield takeLatest(paymentButtonActions.confirmPaymentButton.type, confirmPaymentButton);
}
export function* watchGeneratePaymentButton() {
  yield takeLatest(paymentButtonActions.generatePaymentButton.type, generatePaymentButton);
}
/* istanbul ignore next */
export default function* paymentButtonSaga() {
  yield spawn(watchGeneratePaymentButton);
  yield spawn(watchConfirmPaymentButton);
}
